import React, { useEffect, useState } from 'react';
import api from '../api';
import Modal from '../Modal';
import { Badge } from '../ui';
import { useLang } from '../Layout';
import { FaCheck, FaXmark } from 'react-icons/fa6';

const T = {
  bn: { title: 'মাল অনুরোধ', subOwner: 'কন্ট্রাক্টরদের মাল চাওয়া', subCtr: 'ম্যানেজারের কাছে মাল চাইতে পারেন', request: 'মাল চাই', material: 'মাল', qty: 'পরিমাণ', note: 'নোট', approve: 'অনুমোদন', reject: 'বাতিল', empty: 'কোনো অনুরোধ নেই।', send: 'অনুরোধ পাঠান', select: '— নির্বাচন করুন —' },
  en: { title: 'Material Requests', subOwner: 'Contractor material requests', subCtr: 'Request materials from manager', request: 'Request Material', material: 'Material', qty: 'Quantity', note: 'Note', approve: 'Approve', reject: 'Reject', empty: 'No requests yet.', send: 'Send Request', select: '— Select —' },
};

export default function Requests({ role }) {
  const { lang } = useLang(); const t = T[lang];
  const isOwner = role === 'owner';
  const isContractor = role === 'contractor';
  const [requests, setRequests] = useState([]);
  const [show, setShow] = useState(false);
  const [materials, setMaterials] = useState([]);
  const [form, setForm] = useState({ material_id: '', qty: '', note: '' });
  const [err, setErr] = useState('');

  const load = () => {
    const ep = isContractor ? '/contractor/requests' : isOwner ? '/owner/requests' : '/manager/requests';
    api.get(ep).then(({ data }) => setRequests(data.requests)).catch(() => {});
  };
  useEffect(() => {
    load();
    const matEp = isContractor ? '/contractor/materials' : isOwner ? '/owner/stock/materials' : '/manager/materials';
    api.get(matEp).then(({ data }) => setMaterials(data.materials)).catch(() => {});
  }, []);

  async function submit(e) {
    e.preventDefault(); setErr('');
    try { await api.post('/contractor/requests', form); setShow(false); setForm({ material_id: '', qty: '', note: '' }); load(); }
    catch (e) { setErr(e.response?.data?.message || 'Error'); }
  }
  async function respond(id, status) { await api.post(`/owner/requests/${id}/respond`, { status }); load(); }

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div><h1 className="text-xl font-semibold text-[#0F172A]">{t.title}</h1><p className="text-sm text-[#475569]">{isContractor ? t.subCtr : t.subOwner}</p></div>
        {isContractor && <button className="btn-primary flex items-center gap-2 text-sm" onClick={() => setShow(true)}>+ {t.request}</button>}
      </div>

      {/* Charm card list */}
      <div className="space-y-3">
        {requests.map((r) => (
          <div key={r.id} className="bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.08)] p-5">
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-[#FFFBEB] text-[#F59E0B] flex items-center justify-center">📦</div>
                <div>
                  <div className="font-medium text-[#0F172A]">{r.material_name}</div>
                  <div className="text-xs text-[#94A3B8]">{r.qty} {r.material_unit} • {isContractor ? r.created_at?.slice(0, 10) : `${r.contractor_name} • ${r.created_at?.slice(0, 10)}`}</div>
                </div>
              </div>
              <Badge color={r.status}>{r.status}</Badge>
            </div>
            {r.note && <div className="text-xs text-[#475569] mt-2 ml-12">📝 {r.note}</div>}
            {isOwner && r.status === 'pending' && (
              <div className="flex gap-2 mt-3 ml-12">
                <button onClick={() => respond(r.id, 'approved')} className="flex-1 btn bg-[#047857] hover:bg-[#047857] text-white flex items-center justify-center gap-1 text-sm"><FaCheck /> {t.approve}</button>
                <button onClick={() => respond(r.id, 'rejected')} className="flex-1 btn bg-[#FFFBEB] hover:bg-[#FEF3C7] text-[#B91C1C] flex items-center justify-center gap-1 text-sm"><FaXmark /> {t.reject}</button>
              </div>
            )}
          </div>
        ))}
        {requests.length === 0 && <div className="text-center py-12 text-[#94A3B8] text-sm">{t.empty}</div>}
      </div>

      <Modal open={show} onClose={() => setShow(false)} title={t.request}>
        <form onSubmit={submit} className="space-y-4">
          {err && <div className="text-sm bg-[#FFFBEB] text-[#B91C1C] px-3 py-2 rounded-lg">{err}</div>}
          <div><label className="label">{t.material} <span className="text-[#F59E0B]">*</span></label>
            <select className="input" value={form.material_id} onChange={(e) => setForm({ ...form, material_id: e.target.value })} required><option value="">{t.select}</option>{materials.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}</select></div>
          <div><label className="label">{t.qty} <span className="text-[#F59E0B]">*</span></label><input className="input" type="number" value={form.qty} onChange={(e) => setForm({ ...form, qty: e.target.value })} required /></div>
          <div><label className="label">{t.note}</label><textarea className="input" rows={2} value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} /></div>
          <button className="btn-primary w-full">{t.send}</button>
        </form>
      </Modal>
    </div>
  );
}